/**
 * @module app.shared
 */

import { bindable } from 'aurelia-typed-observable-plugin';

export class EssBadge {

    @bindable.string
    public caption: string = "";

    @bindable.booleanAttr
    public new: boolean = false;

    private spanElement?: HTMLSpanElement;

    constructor() {}

    protected attached(): void {
        this.update(this.caption, this.new);
    }

    protected captionChanged(newCaption: string, oldCaption: string) {
        if(newCaption !== oldCaption) {
            this.update(newCaption, this.new);
        }
    }

    protected newChanged(newValue: boolean, oldValue: boolean) {
        if(newValue !== oldValue) {
            this.update(this.caption, newValue);
        }
    }

    private update(newCaption: string, newValue: boolean): void {
        if(!this.spanElement) { return; }
        if(newValue) {
            this.spanElement.classList.add('new');
        }
        else {
            this.spanElement.classList.remove('new');
        }
        if(newCaption && newCaption.length > 0) {
            this.spanElement.setAttribute('data-badge-caption', newCaption);
        }
        else {
            this.spanElement.removeAttribute('data-badge-caption');
        }
    }

}
